import React, { useEffect, useState, useCallback } from "react";
import styles from "./index.module.css";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";

import { DATE_FORMAT, TIME_FORMAT } from "shared/globals";

import { Auth } from "shared/@auth/Auth";
import Button from "shared/Button";
import Table from "shared/Table";
import Loader from "shared/Loader";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const History = ({ iboNumber }) => {
  const { makeAuthedRequest } = Auth.useContainer();
  const [data, setData] = useState(null);
  const [numResults, setNumResults] = useState(10);

  const refresh = useCallback(() => {
    makeAuthedRequest(
      `/v1/membership/password/history?iboNumber=${iboNumber}&limit=${numResults}`,
      {
        method: "GET",
      }
    )
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          console.error(await res.json());
        }
      })
      .then((history) => {
        setData(history);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [iboNumber, numResults, makeAuthedRequest]);

  useEffect(() => {
    refresh();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.headerTextGroup}>
          <h2>History</h2>
          {data && data.length > 0 && (
            <span className={styles.subtitle}>
              &nbsp;&mdash; last {numResults} results
            </span>
          )}
        </div>
        <Button onClick={refresh} size="small">
          Refresh
        </Button>
      </header>

      {data ? (
        data.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <th>User</th>
                <th>Expires At</th>
                <th>Used At</th>
              </tr>
            </thead>

            <tbody>
              {data.map((record) => (
                <tr
                  key={`${record.wwgUser}_${record.iboNumber}_${record.expiresOn}`}
                >
                  <td>{record.wwgUser}</td>
                  <td>
                    {dayjs(record.expiresOn).format(
                      `${DATE_FORMAT} ${TIME_FORMAT} z`
                    )}
                  </td>
                  <td>
                    {record.usedOn ? (
                      dayjs(record.usedOn).format(
                        `${DATE_FORMAT} ${TIME_FORMAT} z`
                      )
                    ) : (
                      <span className={styles.unused}>Not used</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className={styles.noHistory}>
            No temporary passwords have been generated for this IBO yet.
          </p>
        )
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default History;
